import { useAtom, useAtomValue } from "jotai";
import HeaderLogo from "../Icon/HeaderLogo";
import { isInitModalOpenAtom, isMobileAtom, isShowDrawerInMobileAtom } from "../store";
import BottomSheet from "./BottomSheet";
import { DigilockerInit } from "./DigilockerInit";
import Modal from "./Modal";
import { useLanguage } from "../hooks/useLanguage";

export const ArrowIcon = () => (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M3 8H13M13 8L9 4M13 8L9 12" stroke="#FFF" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
);

export const Button = ({ children, className = "", onClick }: { children: React.ReactNode; className?: string; onClick?: () => void }) => {
    return (
        <div
            className={`idto_digilocker_button ${className}`}
            onClick={onClick}
        >
            {children}
        </div>
    );
};

const Header = () => {
    const isMobile = useAtomValue(isMobileAtom);
    const headerClassName = `idto_digilocker_header ${isMobile ? 'idto_digilocker_header_mobile' : 'idto_digilocker_header_desktop'}`;
    const logoContainerClassName = `idto_digilocker_header_logo_container ${isMobile ? 'idto_digilocker_header_logo_container_mobile' : 'idto_digilocker_header_logo_container_desktop'}`;

    return (
        <div className={headerClassName}>
            <div className={logoContainerClassName}>
                <HeaderLogo color={isMobile ? '#0019FF' : '#E6E8FF'} />
            </div>
        </div>
    );
};

const MobileContent = ({ onOpenInitModal }: { onOpenInitModal: () => void }) => {
    const { t } = useLanguage();
    
    return (
        <div className="idto_digilocker_mobile_content">
            <p className="idto_digilocker_mobile_title">
                {t('mobileTitle')}
            </p>
            <p className="idto_digilocker_mobile_description">
                {t('mobileDescription')}
            </p>
            <p className="idto_digilocker_mobile_disclaimer">
                {t('mobileDisclaimer')}
            </p>
            <Button className="idto_digilocker_mobile_button" onClick={() => onOpenInitModal()}>
                <p className="idto_digilocker_button_text">{t('startAadhaarVerification')}</p>
                <ArrowIcon />
            </Button>
        </div>
    );
};

const DesktopContent = ({ onOpenInitModal }: { onOpenInitModal: () => void }) => {
    const { t } = useLanguage();
    
    return (
        <div className="idto_digilocker_desktop_content">
            <img
                src="https://idto-sdk-bucket.s3.ap-south-1.amazonaws.com/digilocker_logo.png.png"
                className="idto_digilocker_desktop_logo"
                alt={t('digilockerLogoAlt')}
            />
            <p className="idto_digilocker_desktop_title">
                {t('desktopTitle')}
            </p>
            <p className="idto_digilocker_desktop_subtitle">
                {t('desktopSubtitle')}
            </p>
            <p className="idto_digilocker_desktop_description">
                {t('desktopDescription')}
            </p>
            <Button className="idto_digilocker_desktop_button" onClick={() => onOpenInitModal()}>
                <p className="idto_digilocker_button_text">{t('startAadhaarVerification')}</p>
                <ArrowIcon />
            </Button>
            <p className="idto_digilocker_desktop_disclaimer">
                {t('desktopDisclaimer')}
            </p>
        </div>
    );
};

export default function Overview() {
    const isMobile = useAtomValue(isMobileAtom);
    const isShowDrawerInMobile = useAtomValue(isShowDrawerInMobileAtom);
    const [isInitModalOpen, setIsInitModalOpen] = useAtom(isInitModalOpenAtom);

    const onInitModalClose = () => {
        setIsInitModalOpen(false);
    }

    const onInitModalOpen = () => {
        setIsInitModalOpen(true);
    }

    const overviewContainerClassName = `idto_digilocker_overview_container ${isMobile ? 'idto_digilocker_overview_container_mobile' : 'idto_digilocker_overview_container_desktop'}`;

    return (
        <>
            {isMobile && !isShowDrawerInMobile && isInitModalOpen ? <DigilockerInit /> :
                <>
                    <div className={overviewContainerClassName}>
                        <Header />
                        {isMobile ? <MobileContent onOpenInitModal={onInitModalOpen} /> : <DesktopContent onOpenInitModal={onInitModalOpen} />}
                    </div>
                    {isMobile ? <BottomSheet isOpen={isInitModalOpen} onClose={onInitModalClose} children={<DigilockerInit />} /> : <Modal width={'400px'} isOpen={isInitModalOpen} onClose={onInitModalClose} children={<DigilockerInit />} />}
                </>
            }
        </>
    );
}